import { AxiosRequestConfig, AxiosResponse } from 'axios';

import {
  IKnowledgeAreaCategory,
  IKnowledgeAreaCreateData,
  IKnowledgeAreaDetailsResponse,
  IKnowledgeAreaResponse,
  IKnowledgeAreaUpdateData,
} from './knowledge-area.interface';

import { axiosApiInstance } from 'services/config';
import {
  IKnowledgeArea,
  IKnowledgeAreaDetails,
  KnowledgeAreaCategoryNames,
} from 'types/domain/knowledgeArea';
import {
  convertKnowledgeAreaToDetailsView,
  convertKnowledgeAreaToTable,
} from 'utils/knowledge-area';

class KnowledgeAreaApi {
  async getAllByOrgId(
    organizationId: number,
    config?: AxiosRequestConfig,
  ): Promise<IKnowledgeArea[]> {
    const response: AxiosResponse<IKnowledgeAreaResponse[]> = await axiosApiInstance.get(
      `knowledge-area/organization/${organizationId}`,
      config,
    );
    return convertKnowledgeAreaToTable(response.data);
  }

  async getOneById(
    knowledgeAreaId: number,
    config?: AxiosRequestConfig,
  ): Promise<IKnowledgeAreaDetails> {
    const response: AxiosResponse<IKnowledgeAreaDetailsResponse> =
      await axiosApiInstance.get(`knowledge-area/${knowledgeAreaId}`, config);
    return convertKnowledgeAreaToDetailsView(response.data);
  }

  async create(
    knowledgeAreaData: IKnowledgeAreaCreateData,
    config?: AxiosRequestConfig,
  ): Promise<IKnowledgeAreaResponse> {
    const response: AxiosResponse<IKnowledgeAreaResponse> = await axiosApiInstance.post(
      'knowledge-area',
      knowledgeAreaData,
      config,
    );
    return response.data;
  }

  async update(
    knowledgeAreaData: IKnowledgeAreaUpdateData,
    knowledgeAreaId: number,
    config?: AxiosRequestConfig,
  ): Promise<IKnowledgeAreaDetails> {
    const response: AxiosResponse<IKnowledgeAreaDetailsResponse> =
      await axiosApiInstance.put(
        `knowledge-area/${knowledgeAreaId}`,
        knowledgeAreaData,
        config,
      );
    return convertKnowledgeAreaToDetailsView(response.data);
  }

  async delete(knowledgeAreaId: number, config?: AxiosRequestConfig): Promise<void> {
    await axiosApiInstance.delete(`knowledge-area/${knowledgeAreaId}`, config);
  }

  async getAllCategories(
    config?: AxiosRequestConfig,
  ): Promise<KnowledgeAreaCategoryNames> {
    const response: AxiosResponse<[IKnowledgeAreaCategory, IKnowledgeAreaCategory]> =
      await axiosApiInstance.get('category', config);
    return response.data.map(category => category.name) as KnowledgeAreaCategoryNames;
  }

  async updateModified(
    knowledgeAreaId: number,
    config?: AxiosRequestConfig,
  ): Promise<IKnowledgeAreaDetails> {
    const response: AxiosResponse<IKnowledgeAreaDetailsResponse> =
      await axiosApiInstance.patch(
        `knowledge-area/${knowledgeAreaId}`,
        undefined,
        config,
      );
    return convertKnowledgeAreaToDetailsView(response.data);
  }
}

export { KnowledgeAreaApi };
